import {
    ENRICHMENT_CATEGORY_TYPE_CUSTOM,
    ENRICHMENT_CATEGORY_TYPE_PROFILE
} from 'common-data-handling';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import handleLogout from '../../../misc/logout';
import ActionButton from '../../elements/ActionButton/ActionButton';
import ContainedImage from '../../elements/ContainedImage';
import LeftTabbedGrayHeader from '../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import LinkedinLogin from '../authentication/LinkedinLoginButton';
import Screen from '../Screen';
import moment from 'moment';
import styles from './MyProfile.module.scss';

const eventsFilter = function (event) {
    return (
        event.hasEnrichments &&
        moment(event.end_local).add(4, 'weeks').isAfter(moment().add(1,'day').startOf('day'))
    );
};

const enrichmentsFilter = function (enCat) {
    return _.includes(
        [ENRICHMENT_CATEGORY_TYPE_PROFILE, ENRICHMENT_CATEGORY_TYPE_CUSTOM],
        enCat.category
    );
};

class MyProfileScreen extends React.Component {
    componentDidMount() {
        _.defer(app.api.events.fetchUserEvents);
    }
    render() {
        var user = this.props.user;
        var i18n = this.props.i18n;

        var communities = _(this.props.communities)
            .values()
            .filter(eventsFilter)
            .map(function (event) {
                return _(event.enrichment_categories)
                    .values()
                    .filter(enrichmentsFilter)
                    .map(function (enCat) {
                        return (
                            <ActionButton
                                className={styles.ActionButton}
                                key={[
                                    event.id,
                                    enCat.id,
                                    enCat.category,
                                ].join()}
                                next
                                color={event.settings.primary_color}
                                href={[
                                    '/events',
                                    event.id,
                                    'enrich',
                                    enCat.category,
                                ].join('/')}
                            >
                                {event.name}
                                <div className="subtitle">{enCat.label}</div>
                            </ActionButton>
                        );
                    })
                    .value();
            })
            .flatten()
            .compact()
            .value();
        if (communities.length) {
            communities = (
                <div>
                    <LeftTabbedGrayHeader>
                        {i18n['label.community-settings']}
                    </LeftTabbedGrayHeader>
                    <div className="indent">{communities}</div>
                </div>
            );
        }

        var events = _(this.props.events)
            .values()
            .filter(eventsFilter)
            .map(function (event) {
                return _(event.enrichment_categories)
                    .values()
                    .filter(enrichmentsFilter)
                    .map(function (enCat) {
                        var label;
                        if (enCat.category == ENRICHMENT_CATEGORY_TYPE_CUSTOM) {
                            label = event.settings.custom_enrich_label;
                        } else {
                            label = enCat.label;
                        }
                        return (
                            <ActionButton
                                className={styles.ActionButton}
                                key={[
                                    event.id,
                                    enCat.id,
                                    enCat.category,
                                ].join()}
                                next
                                color={event.settings.primary_color}
                                href={[
                                    '/events',
                                    event.id,
                                    'enrich',
                                    enCat.category,
                                ].join('/')}
                            >
                                {event.name}
                                <div className="subtitle">{label}</div>
                            </ActionButton>
                        );
                    })
                    .value();
            })
            .flatten()
            .compact()
            .value();
        if (events.length) {
            events = (
                <div>
                    <LeftTabbedGrayHeader>
                        {i18n['label.event-settings']}
                    </LeftTabbedGrayHeader>
                    <div className="indent">{events}</div>
                </div>
            );
        }

        const header = (
            <>
                <TopBar returnURL=".." />
                <hr />
            </>
        );

        return (
            <Screen header={header}>
                <Scrollable>
                    <LeftTabbedGrayHeader>
                        {i18n['label.my.profile-title']}
                    </LeftTabbedGrayHeader>
                    <div className="indent">
                        <div
                            style={{
                                paddingLeft: 75,
                                height: 64,
                                position: 'relative',
                                marginBottom: 7,
                            }}
                        >
                            <ContainedImage
                                src={user.image_url}
                                altSrc="img/no_avatar.png"
                                style={{
                                    position: 'absolute',
                                    width: 64,
                                    height: 64,
                                    top: 0,
                                    left: 0,
                                    borderRadius: 32,
                                }}
                            />
                            <h2>
                                {[user.first_name, user.last_name].join(' ')}
                            </h2>
                            <ActionButton
                                className={styles.ActionButton}
                                tab
                                next
                                href="./photo"
                            >
                                {i18n['label.photo']}
                            </ActionButton>
                        </div>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            href="./edit"
                        >
                            {i18n['label.edit.profile']}
                        </ActionButton>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            href="./password"
                        >
                            {i18n['label.word.change']}
                        </ActionButton>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            href="./language"
                        >
                            {i18n['label.select.language']}
                        </ActionButton>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            href="./email"
                        >
                            {i18n['label.change.email']}
                        </ActionButton>
                        <LinkedinLogin
                            disableIcon
                            color="mixed"
                            className={styles.ActionButton}
                        >
                            {i18n['label.linkedin-connect']}
                        </LinkedinLogin>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            href="./privacy"
                        >
                            {i18n['label.pivacy.settings']}
                        </ActionButton>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            href="./delete"
                        >
                            {i18n['label.delete.data']}
                        </ActionButton>
                        <ActionButton
                            className={styles.ActionButton}
                            tab
                            next
                            onClick={this.handleLogout.bind(this)}
                        >
                            {i18n['label.logout']}
                        </ActionButton>
                    </div>
                    {communities}
                    {events}
                    <br />
                </Scrollable>
            </Screen>
        );
    }
    handleLogout() {
        handleLogout();
    }
}

export default connect(function (state, props) {
    return {
        i18n: state.i18n.translations,
        user: state.session.user,
        communities: _(state.events)
            .values()
            .map('event')
            .filter({ _isCommunity: true })
            .value(),
        events: _(state.events)
            .values()
            .map('event')
            .filter({ _isEvent: true })
            .value(),
    };
})(MyProfileScreen);
